import { Maybe } from '../../types/utility'
import { isDefined } from '../common/isDefined'

export function clamp(value: Maybe<number>, min?: Maybe<number>, max?: Maybe<number>) {
  if (!isDefined(min) || !isDefined(max)) {
    return value
  }
  return Math.min(Math.max(value as number, min), max)
}

export const clampFp = (min: Maybe<number>, max: Maybe<number>) => (value: number) => clamp(value, min, max)
